import { getItem } from "@/utils/localStorageControl.js";
import { logOut } from "../services/authservices";

// eslint-disable-next-line no-unused-vars
import { handleRouting } from "@/utils/constants";

export default function auth({ to, next, store }) {
  const isLoggedIn = store.getters.isLoggedIn;
  const adminCategory = [0, 3, 4];
  const userApps = store.getters.userApps;
  const selectedApp =
    getItem("selectedApp") || process.env.VUE_APP_MATTA_APP_CODE;
  const userCategory = store.getters.loggedUser?.userCategory;

  // Check if the route requires authentication
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (isLoggedIn) {
      if (
        adminCategory.includes(userCategory) &&
        userApps?.includes(selectedApp)
      ) {
        next();
      } else {
        logOut();
      }
    } else {
      handleRouting();

      // window.location.href = "/login";
    }
  } else {
    next();
  }
}
